export default "__VITE_ASSET__DwhM3VgU__"